import { create } from 'zustand';

export type ModalState = 'idle' | 'loading' | 'error' | 'loaded';

interface HistoryState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useHistoryStore = create<HistoryState>()((set) => ({
  open: false,
  games: [],
  setOpen: (open) => set(() => ({ open })),
}));
